import { createFileRoute, redirect } from '@tanstack/react-router'
import { AdminSignup } from '@/features/admin-signup'
import { hasBackOfficeAccess } from '@/lib/auth'
import { getCachedAuth } from '@/lib/auth-cache'

export const Route = createFileRoute('/(auth)/admin-signup')({
  beforeLoad: () => {
    // Only use cached auth (set by AuthProvider) - no network call
    const { cachedUserRole } = getCachedAuth()
    if (cachedUserRole && hasBackOfficeAccess(cachedUserRole)) {
      throw redirect({ to: '/' })
    }
  },
  component: AdminSignup,
})
